import { createAction } from '@mews/framework/redux';
import { AuthorizePaymentCardResult } from '@mews-distributor/data-access';
import {
    AUTHORIZE_PAYMENT_CARD_FAILED,
    AUTHORIZE_PAYMENT_CARD_STARTED,
    AUTHORIZE_PAYMENT_CARD_SUCCEEDED,
} from '../../modules/entities/paymentCardAuthorizations/actionTypes';
import type { DistributorPromiseThunkAction } from '../../types';

interface AuthorizePaymentCardParams {
    enterpriseId: string;
    paymentCardId: string;
}

export const authorizePaymentCard =
    ({
        enterpriseId,
        paymentCardId,
    }: AuthorizePaymentCardParams): DistributorPromiseThunkAction<AuthorizePaymentCardResult> =>
    async (dispatch, _getState, { apiService }) => {
        dispatch(createAction(AUTHORIZE_PAYMENT_CARD_STARTED, { enterpriseId, paymentCardId }));

        return apiService
            .authorizePaymentCard({ enterpriseId, paymentCardId })
            .then((paymentCardAuthorization) => {
                dispatch(createAction(AUTHORIZE_PAYMENT_CARD_SUCCEEDED, paymentCardAuthorization));
                return paymentCardAuthorization;
            })
            .catch((error) => {
                dispatch(createAction(AUTHORIZE_PAYMENT_CARD_FAILED, { error, enterpriseId }));
                throw error;
            });
    };
